<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/10oi5X4/tc-custom/9781466843592.jpg?1734032678695" alt="This image is the cover for the book Industry of Souls"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Industry of Souls
      </h1>
      <p class="bookDescription body article font2">
        <b>After serving twenty-five years in a Soviet labor camp, a convicted British spy becomes a schoolmaster in a Russian village in this “gripping” novel (<i>Kirkus Reviews</i>).</b><br/><br/><b>“As we accompany Bayliss on a tour through his present and past, this meditative, unadorned novel, short-listed for the Booker Prize in 1998, raises questions about home, freedom, and the meaning of a life that resonate long after the final page is turned.” —<i>The New York Times Book Review</i></b><br/><br/><i>The Industry of Souls</i> is the story of Alexander Bayliss, a British citizen who was wrongfully arrested for espionage by the KGB in the 1950s and sentenced to twenty-five years of hard labor in the work camps of Siberia. Eventually freed in the 1970s, he decides not to return to the West—a world he barely remembers and to which he no longer belongs—and instead finds his way to a small Russian village where he becomes a much beloved schoolmaster.<br/><br/>Now, on the day of his eightieth birthday, communism has evaporated and Russia is changed. This moving story alternates between this momentous day to his harrowing past in the camp and his life in the village. And in the end, he is presented with a choice, perhaps for the first time in his life.<br/><br/>Martin Booth’s brilliantly crafted novel is a celebration of life in the face of death, of humanity in the midst of a system that robs men of their dignity. It stands as a mature and profound exploration of the meaning of freedom and the essence of human friendship.<br/><br/><b>“[Bayliss’s] story is at once horrifying and deeply affecting, a paean to what is eternal in the Russian spirit—and the work of a sharp-eyed humanist whose powers are at full stretch.” —<i>Publishers Weekly</i> (starred review)</b><br/><br/><b>“The scene is the heart of Russia, and Booth deserves special credit for conveying it with a convincing sense of reality for those who are less familiar with Russia, and with a sense of recognition for those who know Russia well.” —<i>Chicago Tribune</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Martin Booth
      </h2>
      
      <p class="authorDescription body article"><P>This is <B>MARTIN BOOTH</B>'s twelfth adult novel.  His most recent nonfiction books include <I>The Doctor and the Detective: A Biography of Sir Arthur Conan Doyle</I> and <I>Opium: A History</I>.  An inveterate traveler, Martin Booth frequently broadcasts for the BBC.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Picador USA
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?9eb9f002